import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function newEquipement(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_EQUIPEMENT_START", payload: "" })
            
            console.log("new Equipement START", {data})
            const res = await axios.post('/equipements/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_EQUIPEMENT_ERROR", dispatch ) ) {
                // res.data.equipement_name = capitalizeWord(res.data.equipement_name)
				dispatch({ type: "NEW_EQUIPEMENT_LIST", payload: formatList(res.data, "equipement_id")  })
				dispatch({ type: "CREATE_EQUIPEMENT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new equipement ", err);
            dispatch({
                type: "CREATE_EQUIPEMENT_ERROR",
                payload: err
            })
        }
    }
}
export function newVehicule(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_VEHICULE_START", payload: "" })
            
            console.log("new Equipement START", {data})
            const res = await axios.post('/vehicules/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_VEHICULE_ERROR", dispatch ) ) {
                // res.data.equipement_name = capitalizeWord(res.data.equipement_name)
				dispatch({ type: "NEW_VEHICULE", payload: res.data })
				dispatch({ type: "CREATE_VEHICULE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new equipement ", err);
            dispatch({
                type: "CREATE_VEHICULE_ERROR",
                payload: err
            })
        }
    }
}

export function fetchVehicules() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_VEHICULES_START", payload: "" })

            console.log("fetch Vehicule START")
            const res = await axios.get('/vehicules/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_VEHICULES_ERROR", dispatch ) ) {               
                let list = orderByAsc(res.data, "equipement_name")
                dispatch({
                    type: "GET_VEHICULES",
                    payload: formatList(list, "equipement_id")
                })
                dispatch({ type: "FETCH_VEHICULES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get vehicules list ", err);
            dispatch({ type: "FETCH_VEHICULES_ERROR", payload: err })
        }
    }
}

export function fetchEquipements() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_EQUIPEMENTS_START", payload: "" })

            console.log("fetch Equipement START")
            const res = await axios.get('/equipements/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_EQUIPEMENTS_ERROR", dispatch ) ) {               
                let list = orderByAsc(res.data, "equipement_name")
                // let list = capitalize(orderByAsc(res.data, "equipement_name"), "equipement_name")
                dispatch({
                    type: "GET_EQUIPEMENTS",
                    payload: formatList(list, "equipement_id")
                })
                dispatch({ type: "FETCH_EQUIPEMENTS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get equipements list ", err);
            dispatch({ type: "FETCH_EQUIPEMENTS_ERROR", payload: err })
        }
    }
}
export function fetchImmoTags() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_TAGS_START", payload: "" })

            console.log("fetch tags START")
            const res = await axios.get('/equipements/tags/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_TAGS_ERROR", dispatch ) ) {               
                let list = orderByAsc(res.data, "immo_tag_name")
                // let list = capitalize(orderByAsc(res.data, "equipement_name"), "equipement_name")
                dispatch({
                    type: "GET_IMMO_TAGS",
                    payload: formatList(list, "immo_tag_id")
                })
                dispatch({ type: "FETCH_TAGS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get tags list ", err);
            dispatch({ type: "FETCH_TAGS_ERROR", payload: err })
        }
    }
}

export function updateEquipement(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_EQUIPEMENT_START", payload: "" })

            console.log("update Equipement START")
            const res = await axios.post("/equipements/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_EQUIPEMENT_ERROR", dispatch ) ) {               
                // data.equipement_name = capitalizeWord(data.equipement_name)
				dispatch({
                    type: "UPDATE_EQUIPEMENT",
                    payload: res.data.equipement
                })
				dispatch({ type: "UPDATE_EQUIPEMENT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update equipement ", err);
            dispatch({
                type: "UPDATE_EQUIPEMENT_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateVehicule(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_VEHICULE_START", payload: "" })

            console.log("update Equipement START")
            const res = await axios.post("/equipements/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_VEHICULE_ERROR", dispatch ) ) {               
                // data.equipement_name = capitalizeWord(data.equipement_name)
				dispatch({
                    type: "UPDATE_VEHICULE",
                    payload: data
                })
				dispatch({ type: "UPDATE_VEHICULE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update equipement ", err);
            dispatch({
                type: "UPDATE_VEHICULE_ERROR",
                payload: err
                
            })
        }
    }
}
export function updateEquipementPics(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_EQUIPEMENT_START", payload: "" })

            console.log("update Equipement START")
            const res = await axios.post("/equipements/pics/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_EQUIPEMENT_ERROR", dispatch ) ) {               
                // data.equipement_name = capitalizeWord(data.equipement_name)
				dispatch({
                    type: "UPDATE_EQUIPEMENT",
                    payload: res.data
                })
				dispatch({ type: "UPDATE_EQUIPEMENT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update equipement ", err);
            dispatch({
                type: "UPDATE_EQUIPEMENT_ERROR",
                payload: err
                
            })
        }
    }
}

export function updateVehiculePics(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_VEHICULE_START", payload: "" })

            console.log("update Equipement START")
            const res = await axios.post("/equipements/pics/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_VEHICULE_ERROR", dispatch ) ) {               
                // data.equipement_name = capitalizeWord(data.equipement_name)
				dispatch({
                    type: "UPDATE_VEHICULE",
                    payload: res.data
                })
				dispatch({ type: "UPDATE_VEHICULE_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update equipement ", err);
            dispatch({
                type: "UPDATE_VEHICULE_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteEquipement(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_EQUIPEMENT_START", payload: "" })

            console.log("delete equipement START")
            const res = await axios.post("/equipements/delete", {data: data.equipement_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_EQUIPEMENT_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_EQUIPEMENT",
                    payload: data.equipement_id,
                })
                dispatch({ type: "DELETE_EQUIPEMENT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete equipement ", err);
            dispatch({
                type: "DELETE_EQUIPEMENT_ERROR",
                payload: err
            })
        }
    }
}